import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PortalCmctiRoutingModule } from './portal-cmcti-routing.module';
import { CmCTIComponent } from './cm-cti/cm-cti.component';
import { RodapeComponent } from './rodape/rodape.component';
import { PortalComponent } from './portal/portal.component';
import { PortalDirective } from './portal/portal.directive';
import { CabecarioComponent } from './cabecario/cabecario.component';
import { NoticiasComponent } from './noticias/noticias.component';
import { CompetenciasComponent } from './competencias/competencias.component';
import { ComposicaoComponent } from './composicao/composicao.component';
import { GaleriaComponent } from './galeria/galeria.component';
import { CalendarioComponent } from './calendario/calendario.component';
import { CalendarioDirective } from './calendario/calendario.directive';
import { MaterializeModule } from 'angular2-materialize';
import { GalleryModule } from '@ngx-gallery/core';
import { LightboxModule } from '@ngx-gallery/lightbox';
import { MomentModule } from 'angular2-moment';
import { AppRoutingModule } from '../app-routing.module';
import { RouterModule } from '@angular/router';
import { NoticiasService } from './noticias/noticias.service';
import { GaleriaService } from './galeria/galeria.service';
import { ArrayObjeto } from './noticias/array-objeto.pipe';
import { LegislacaoComponent } from './legislacao/legislacao.component';
import { AtasComponent } from './atas/atas.component';
import { PautasComponent } from './pautas/pautas.component';

@NgModule({
  imports: [
    CommonModule,
    PortalCmctiRoutingModule,
    MaterializeModule,
    GalleryModule.forRoot(),
    LightboxModule.forRoot(),
    MomentModule,
    MaterializeModule,
  ],
  declarations: [
    CmCTIComponent,
    RodapeComponent,
    PortalComponent,
    PortalDirective,
    CabecarioComponent,
    NoticiasComponent,
    CompetenciasComponent,
    ComposicaoComponent,
    GaleriaComponent,
    CalendarioComponent,
    CalendarioDirective,
    ArrayObjeto,
    LegislacaoComponent,
    AtasComponent,
    PautasComponent,
  ],
  exports: [
    CmCTIComponent,
    RodapeComponent,
    PortalComponent,
    PortalDirective,
    CabecarioComponent,
    NoticiasComponent,
    CompetenciasComponent,
    ComposicaoComponent,
    GaleriaComponent,
    CalendarioComponent,
    CalendarioDirective,
    LegislacaoComponent,
    AtasComponent,
    PautasComponent
  ],
  providers: [NoticiasService, GaleriaService],
  bootstrap: []
})
export class PortalCmctiModule { }



// WEBPACK FOOTER //
// ./src/app/portal-cmcti/portal-cmcti.module.ts